//React
//Components
import { Screen, TranslatedString } from "components";
import React, { useEffect } from "react";
import ROUTE_PATH from "Routes/paths";
import { setGeneralDetails, useGeneralDetails } from "Slices";
//Utils
import { ChangeHistory, history } from "utils";
//Styles
import "./styles.scss";
const Landing = () => {
  //useEffects
  useEffect(() => {
    if (history.location.pathname === "/platforms") {
      ChangeHistory("push", ROUTE_PATH.PLATFORM.HOME);
    }
  }, []);

  //Return UI
  return <Screen className="landing-screen"></Screen>;
};

export default Landing;
